import { COLOR } from 'constants/colors';
import React from 'react';

interface fillColorProps{
    filled?: boolean;
}

export const CallIconWhite: React.FC <fillColorProps>= ({filled}:fillColorProps ) => {
    return <span style={ { marginTop: '2px' } }>
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M12.4223 9.44501L10.5173 9.22751C10.0598 9.17501 9.60979 9.33251 9.28729 9.65501L7.90729 11.035C5.78479 9.95501 4.04479 8.22251 2.96479 6.09251L4.35229 4.70501C4.67479 4.38251 4.83229 3.93251 4.77979 3.47501L4.56229 1.58501C4.47229 0.827507 3.83479 0.257507 3.06979 0.257507H1.77229C0.924786 0.257507 0.219786 0.962507 0.272286 1.81001C0.669786 8.21501 5.79229 13.33 12.1898 13.7275C13.0373 13.78 13.7423 13.075 13.7423 12.2275V10.93C13.7498 10.1725 13.1798 9.53501 12.4223 9.44501Z" 
            fill= { filled ? `${COLOR.GREEN}`:"white"} />
        </svg>
    </span>
}
